import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Upload,
  DatePicker,
  Row,
  Col,
  message,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  createStudentHistory,
  updateStudentHistory,
} from "../../store/studentHistorySlice";
const AddStudentHistoryForm = ({
  open,
  onCancel,
  onSave,
  initialValues,
  onSaveFail,
  mode,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const storedUser = localStorage.getItem("userInfo");
  const userData = storedUser ? JSON.parse(storedUser) : null;
  const storedToken = localStorage.getItem("token");
  const studentId = userData.studentIds?.[0];
  const defaultTime = { defaultValue: dayjs().hour(6).minute(0).second(0) };

  if (!userData || !storedToken) {
    throw new Error("No user data or token found");
  }

  const [imagePath, setImagePath] = useState({
    document: "",
  });

  const [imagePreviews, setImagePreviews] = useState({
    document: null,
  });

  const [base64Strings, setBase64Strings] = useState({
    document: "",
  });
  // Format the initial values
useEffect(() => {
  if (mode === "edit" && initialValues?.document) {
    // Assuming initialValues.document holds the base64 data
    const binaryString = initialValues.document; // Replace this with your actual binary data
    setBase64Strings((prev) => ({ ...prev, document: binaryString }));
    setImagePreviews((prev) => ({
      ...prev,
      document: `data:image/png;base64,${binaryString}`,
    }));
    setImagePath((prev) => ({ ...prev, document: "" })); // Clear the file name
  }
}, [initialValues, mode]);

    const { entryDate, exitDate, ...otherValues } = initialValues || {};
    const formattedInitialValues = {
      ...otherValues,
      entryDate: initialValues?.entryDate
        ? dayjs(initialValues.entryDate)
        : dayjs().hour(6).minute(0).second(0),

      exitDate: initialValues?.exitDate
        ? dayjs(initialValues.exitDate)
        : dayjs().hour(6).minute(0).second(0),

      // We leave the dates out, they will be handled as null in the form
    };
  console.log("initialValues", initialValues);
  console.log("formattedInitialValues", formattedInitialValues);

  const handleFileChange = (event, fieldName) => {
    console.log("handleFileChange: ---->", fieldName);
    const file = event.target.files[0];
    console.log("handleFileChange: ---->", file);

    if (file) {
      setImagePath((prev) => ({
        ...prev,
        [fieldName]: file.name,
      }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviews((prevState) => ({
          ...prevState,
          [fieldName]: reader.result,
        }));
        setBase64Strings((prevState) => ({
          ...prevState,
          [fieldName]: reader.result.split(",")[1], // Save only the Base64 part
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFinish = async () => {
    try {
      const values = await form.validateFields();
      console.log("values", values);
      console.log("studentId", studentId);
      const studentHistoryId = initialValues?.studentHistoryId;
      const action =
        mode === "create" ? createStudentHistory : updateStudentHistory;
      console.log("mode", mode);
      console.log("studentHistoryId", studentHistoryId);
      console.log("base64Strings", base64Strings);

      // Dispatch action with studentId and form data
      const resultAction = await dispatch(
        action({
          studentId,
          studentHistoryId,
          base64Strings,
          schoolData: values,
        })
      );
      if (action.fulfilled.match(resultAction)) {
        onSave();
      } else if (action.rejected.match(resultAction)) {
        // Show the error message returned from the backend
        onSaveFail(action.error || "Failed to submit data");
      }
      // Call the onSave function to refresh data and close the modal
    } catch (error) {
      onSaveFail(error.message || "Failed to submit data");
    }
  };

  const handleBeforeUpload = (file) => {
    const isImageOrPdf =
      file.type === "application/pdf" || file.type.startsWith("image/");

    if (!isImageOrPdf) {
      message.error("You can only upload JPG/PNG file or PDF!");
    }
    return isImageOrPdf;
  };
  
  return (
    <Modal
      title={
        mode === "create"
          ? "Add Student History Information"
          : "Edit Student History Information"
      }
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        form={form}
        initialValues={formattedInitialValues}
        layout="vertical"
        onFinish={handleFinish}
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="schoolName"
              label="School Name"
              rules={[
                { required: true, message: "Please input the school name!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="schoolPhoneNumber"
              label="School Phone Number"
              rules={[
                {
                  required: true,
                  message: "Please input the school phone number!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="gradeFrom"
              label="Grade From"
              rules={[
                { required: true, message: "Please input the grade number!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="gradeTo"
              label="Grade To"
              rules={[
                { required: true, message: "Please input the grade number!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="entryDate"
              label="Entry Date"
              rules={[{ required: true, message: "Please select entry date!" }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showTime={defaultTime}
                format="YYYY-MM-DD HH:mm:ss"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="exitDate"
              label="Exit Date"
              rules={[{ required: true, message: "Please select entry date!" }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showTime={defaultTime}
                format="YYYY-MM-DD HH:mm:ss"
              />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              name="schoolAddress"
              label="School Address"
              rules={[
                { required: true, message: "Please input the school address!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item name="Certification" label="Certification">
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => handleFileChange(e, "document")}
                className={`mt-1 block w-full text-sm text-gray-500`}
              />
            </Form.Item>
            {imagePath.document && <p className="mt-2">{imagePath.document}</p>}
            {imagePreviews.document && (
              <img
                src={imagePreviews.document}
                alt="Uploaded Preview"
                className="mt-4 w-full h-auto"
              />
            )}
            <p
              className={`mt-1 text-sm ${
                imagePath.document ? "text-gray-500" : "text-gray-300"
              }`}
            >
              Upload your Files (Only for foreigners)
            </p>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {mode === "create" ? "Add" : "Update"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddStudentHistoryForm;
